import { isUuid } from '@common/utils/uuid';

type ApiErrorResponse = {
    errorCode?: string;
    message: string;
    statusCode: number;
};
export type FetchErrorMessage = {
    apiErrorResponse: ApiErrorResponse;
    error?: Error;
    method: string;
    url: string;
};

function getPathWithoutQuery(url: string): string | undefined {
    const path = new URL(url, 'http://example.com').pathname;

    return path
        ?.split('/')
        .map((part) => (isUuid(part) ? '?' : part))
        .join('/');
}

export class FetchError extends Error {
    public apiErrorResponse?: ApiErrorResponse;
    public innerError?: Error | string;
    public dd_fingerprint: string;

    constructor(fetchErrorMessage: FetchErrorMessage) {
        super(`Status: ${fetchErrorMessage.apiErrorResponse?.statusCode} Url: ${fetchErrorMessage.url}`);
        this.name = 'FetchError';
        if (fetchErrorMessage?.error instanceof Error) {
            this.stack = fetchErrorMessage?.error.stack;
        }
        this.innerError = fetchErrorMessage?.error;
        this.apiErrorResponse = fetchErrorMessage.apiErrorResponse;

        //this is used for DD to make custom grouping hence the underscore
        this.dd_fingerprint = `${fetchErrorMessage.apiErrorResponse?.statusCode || 'No Status'} ${getPathWithoutQuery(fetchErrorMessage.url)}`;
    }
}
